<template inherit-attrs="false">
  <slot v-if="loading" name="loading">
    <div class="flex flex-auto items-center justify-center h-full">
      <span class="empty-text">Loading...</span>
    </div>
  </slot>
  <component :is="result" v-else-if="result" ref="comp" v-bind="$attrs">
    <template v-for="k in Object.keys($slots)" #[k]="itemBind">
      <slot :name="k" v-bind="itemBind" />
    </template>
  </component>
  <!-- <result v-else-if="result" ref="comp" v-bind="$attrs">
    <template v-for="k in Object.keys($slots)" #[k]="itemBind">
      <slot :name="k" v-bind="itemBind" />
    </template>
  </result> -->
  <slot v-else name="empty">
    <span clas="empty-text">Empty</span>
  </slot>
</template>
<script lang="ts">
export default {
  inheritAttrs: false,
};
</script>
<script setup lang="ts">
import merge from "deepmerge";
import { isPlainObject } from "is-plain-object";
import type { ComponentPublicInstance } from "vue";
import { getCurrentInstance, inject, onMounted, ref, watch } from "vue";
import { usePromiseLazy } from "vue-composable";
import { loadComponent, loadComponentData } from "../../../utils/component";
import { buildMedicusUrl } from "../../../utils/route";

const props = defineProps({
  url: {
    type: String,
    required: true,
  },

  componentPath: String,

  noData: Boolean,

  refreshEvent: {
    type: [String, Array],
    default: (props: any) => (props.noData ? "" : "reloadData"),
  },

  noRefresh: Boolean,

  disable: Boolean,
  disabled: Boolean,

  reload: Boolean,
});

const medicusLoading = inject("medicus:loading", ref(false));

const proxy = getCurrentInstance().proxy!;
const initialTenant = proxy.$tenant;

const comp = ref<ComponentPublicInstance>();

defineExpose({
  comp,
});

const { result, loading, exec } = usePromiseLazy((url: string) =>
  loadComponent(url, props.noData, props.componentPath),
);

const { exec: refreshData } = usePromiseLazy(
  () =>
    !props.noData &&
    loadComponentData(props.url, props.componentPath).then((x: any) => {
      if (comp.value) {
        Object.assign(
          comp.value.$data,
          merge(comp.value.$data, x, {
            isMergeableObject: isPlainObject,
          }),
        );
      }
    }),
);

watch(
  () => [props.url, medicusLoading.value] as const,
  ([x, loading], prev) => {
    if (prev) {
      const [purl] = prev;

      const prevMedicus = buildMedicusUrl(purl);
      const currMedicus = buildMedicusUrl(x);

      if (prevMedicus.componentPath === currMedicus.componentPath && !props.reload) {
        if (prevMedicus.data !== currMedicus.data) {
          refreshData();
        }
      } else {
        exec(x);
      }
    }
    // do not reuse the same instance if the tenant has changed
    else if (initialTenant === proxy.$tenant && !loading) {
      exec(x);
    }
  },
  { immediate: true },
);

onMounted(() => {
  if (!props.noRefresh && props.refreshEvent) {
    const events = Array.isArray(props.refreshEvent)
      ? (props.refreshEvent as string[])
      : props.refreshEvent.split(",").map((x) => x.trim());

    events.forEach((x) => {
      // NOTE disabling `reload` to fully refresh
      // if (props.reload) {
      //   proxy.$listen(x, () => exec(props.url));
      // } else {
      proxy.$listen(x, refreshData);
      // }
    });
  }

  // eslint-disable-next-line no-undef
  if (IS_APP && import.meta.env.NODE_ENV === "development") {
    // proxy.$listen("_devReload", () => exec(props.url));
    proxy.$listen("_devReload", async () => {
      const script = await loadComponent(props.url, props.noData, props.componentPath);

      const data = script.data;
      const prevData = comp.value?.$data;
      script.data = function () {
        const d = data?.call(this);
        return merge(d, prevData);
      };

      result.value = script;
    });
  }
});
</script>
